import React from 'react'
import { Col, Row, Container } from "react-bootstrap";
import BreadcrumbLayout from "../../component/Breadcrumb";
import HeadPara2 from "../../component/HeadPara2";
import { useTranslation } from "react-i18next";
function CopyrightPolicy() {
  const { t } = useTranslation();
  const CopyrightPolicyData = t("CopyrightPolicy", { returnObjects: true });
  return (

    <>
      <BreadcrumbLayout title="Copyright Policy" />
      <Container fluid >
        <Row>
          <Col md={12} className="content order-md-last order-first">
            <Row>
              <Col xs={12} className="heading">
                <h3>{CopyrightPolicyData.title}</h3>
              </Col>
              <Col xs={12} className="mb-1 mt-1">
                {CopyrightPolicyData.data.map((items,i) => (
                  <HeadPara2 key={i} data={items} />
                ))}
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default CopyrightPolicy
